import Bind from 'bind.js';

export default class Gallery {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.createSlideTemplate();
    this.addSlides();
    this.loadSlick();
  }

  createSlideTemplate() {
    let template = `<div class="gallery-images"></div>`;

    this.parentElement.insertAdjacentHTML("afterbegin", template);
  }

  addSlides() {
    this.gallery = Bind(
      {images: this.data.get('images').toJS()},
      {
        images: {
          dom: '.gallery-images',
          transform: function (slide) {
            let className = (slide.src === "webAssets/images/upload.png") ? "upload-preview"
                                                                       : "";

            return `<div class="gallery-slide">
              <img class="${className}" src="${slide.src}"/>
            </div>`;
          }
        }
      }
    );
  }

  onSlickLoad({onLoad, initialSlide}) {
    window.slickLoaded = true;
    if (onLoad) onLoad();
    let parentElement = this.parentElement;
    let parentDiv = this.parentElement.getElementsByTagName('div')[0];
    $(parentDiv).slick({
      dots: false,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },{
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    });

    var resizeCallback = function() {
      var images = parentElement.getElementsByTagName('img');

      for (var i=0; i<images.length; i++) {
        images[i].style.height = (images[i].offsetWidth * (9/16)) + 'px';
      }

      parentElement.style.height = (images[0].offsetWidth * (9/16)) + 'px';
    };

    addResizeListener(parentElement, resizeCallback);
  }

  isSlickLoaded(url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
      if ($(scripts[i]).attr('src') === url)  {
        if (window.slickLoaded) {
          this.onSlickLoad({});
          return true;
        }

        let onLoad = scripts[i].onload;

        scripts[i].onload = () => {this.onSlickLoad({onLoad})};

        return true;
      }
    }
    return false;
  }


  loadSlick() {
    let scriptLoaded = this.isSlickLoaded("js/slick.js");

    if (scriptLoaded) return;

    let slickScript = document.createElement('script');
    slickScript.setAttribute("type","text/javascript");
    slickScript.setAttribute("src", "js/slick.js");

    let slickCSS = document.createElement("link");
    slickCSS.setAttribute("rel", "stylesheet");
    slickCSS.setAttribute("type", "text/css");
    slickCSS.setAttribute("href", "styles/slick.css");

    let slickThemeCSS = document.createElement("link");
    slickThemeCSS.setAttribute("rel", "stylesheet");
    slickThemeCSS.setAttribute("type", "text/css");
    slickThemeCSS.setAttribute("href", "styles/slick-theme.css");

    slickScript.onload = () => {this.onSlickLoad()};

    document.getElementsByTagName("head")[0].appendChild(slickScript);
    document.getElementsByTagName("head")[0].appendChild(slickCSS);
    document.getElementsByTagName("head")[0].appendChild(slickThemeCSS);
  }

  reRender(data) {
    this.data = data;
    let parentDiv = this.parentElement.childNodes[0];
    $(parentDiv).slick('unslick');
    let currentSlide = $(parentDiv).slick('slickCurrentSlide');

    if ((currentSlide + 1) > data.get('images').count()) {
      currentSlide = data.get('images').count() - 1;
    }

    this.gallery.images = data.get('images').toJS();

    this.onSlickLoad({initialSlide: currentSlide});
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Gallery.js